import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck,FiStar,FiGift,FiShield,FiClock,FiUsers,FiGraduationCap,FiArrowRight}=FiIcons;

const InvestmentSection=()=> {
  const includes=[
    "เอกสารคัมภีร์ศาสตร์ปาจื้อ ฉบับเฉพาะ",
    "บัญชีพรีเมียมแอป Bazi by FengshuiX (มูลค่า 5,900 บาท)",
    "กรอบการสร้างแผนปฏิบัติการ Bazi ส่วนตัว",
    "สิทธิ์ในกลุ่มศิษย์เก่า สำหรับการปรึกษาต่อเนื่อง",
    "ใบประกาศนียบัตร จากผู้เชี่ยวชาญด้าน Bazi"
  ];

  return (
    <section className="py-20 relative" id="investment">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-yellow-900/10 to-slate-900"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8">
            การลงทุนเพื่อเข้าถึงศาสตร์แห่งปาจื้อ (八字,Bazi)
          </h2>
          <p className="text-xl text-slate-300 font-light max-w-4xl mx-auto leading-relaxed">
            นี่ไม่ใช่ค่าใช้จ่าย แต่คือ <span className="text-yellow-400 font-medium">"การลงทุนในปัญญา"</span> เพื่อแลกกับความเข้าใจที่จะประหยัดเวลา,ลดความผิดพลาด,และสร้างโอกาสให้คุณไปตลอดชีวิต
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div
          className="bg-gradient-to-br from-yellow-500/10 to-orange-500/10 backdrop-blur-lg rounded-3xl p-12 border border-yellow-500/20 max-w-4xl mx-auto mb-16"
          initial={{opacity: 0,scale: 0.9}}
          whileInView={{opacity: 1,scale: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          {/* Special Offers */}
          <div className="space-y-4 mb-8">
            <motion.div
              className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-3 rounded-full text-lg font-medium mx-auto w-fit flex items-center space-x-2"
              animate={{scale: [1,1.05,1]}}
              transition={{duration: 2,repeat: Infinity}}
            >
              <SafeIcon icon={FiUsers} className="w-5 h-5" />
              <span>🔥 ราคาพิเศษ 9 คนแรกเท่านั้น! 🔥</span>
            </motion.div>
            
            <motion.div
              className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-8 py-3 rounded-full text-lg font-medium mx-auto w-fit flex items-center space-x-2"
              animate={{scale: [1,1.03,1]}}
              transition={{duration: 2.5,repeat: Infinity}}
            >
              <SafeIcon icon={FiGraduationCap} className="w-5 h-5" />
              <span>🎓 นักศึกษา (อายุไม่เกิน 24 ปี) ลดเพิ่ม 2,000 บาท (7 คนเท่านั้น) 🎓</span>
            </motion.div>
          </div>

          <div className="text-center mb-10">
            <div className="text-slate-400 text-xl line-through mb-2">ราคาปกติ: ฿35,000</div>
            <div className="text-6xl font-light text-yellow-400 mb-4">฿9,580</div>
            <p className="text-lg text-slate-300 font-light mb-4">
              ประหยัดทันที <span className="text-orange-400 font-medium">฿25,420</span>
            </p>
            
            {/* Student Pricing */}
            <div className="bg-gradient-to-r from-blue-500/20 to-indigo-500/20 rounded-2xl p-6 border border-blue-500/20 mb-6">
              <div className="text-2xl font-light text-blue-200 mb-2">
                ราคาพิเศษนักศึกษา: <span className="text-3xl font-medium text-blue-400">฿7,580</span>
              </div>
              <p className="text-blue-200 text-sm">
                *ต้องแสดงบัตรนักศึกษา และอายุไม่เกิน 24 ปี
              </p>
            </div>
            
            {/* Urgency Timer */}
            <motion.div
              className="bg-gradient-to-r from-red-500/20 to-orange-500/20 rounded-2xl p-4 border border-red-500/20"
              animate={{scale: [1,1.02,1]}}
              transition={{duration: 2,repeat: Infinity}}
            >
              <div className="flex items-center justify-center space-x-2 text-orange-200">
                <SafeIcon icon={FiClock} className="w-5 h-5" />
                <span className="font-medium">ที่นั่งจำกัด! อย่าพลาดโอกาสนี้</span>
              </div>
            </motion.div>
          </div>

          {/* What's Included */}
          <div className="bg-white/5 rounded-2xl p-8 mb-8">
            <h4 className="text-2xl font-light text-white mb-6 text-center">สิ่งที่คุณจะได้รับ:</h4>
            <div className="space-y-4">
              {includes.map((item,index)=> (
                <motion.div
                  key={index}
                  className="flex items-start space-x-3"
                  initial={{opacity: 0,x: -20}}
                  whileInView={{opacity: 1,x: 0}}
                  transition={{duration: 0.5,delay: index * 0.1}}
                  viewport={{once: true}}
                >
                  <SafeIcon icon={FiCheck} className="w-6 h-6 text-green-400 mt-1 flex-shrink-0" />
                  <span className="text-slate-300 font-light leading-relaxed">{item}</span>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Event Details */}
          <div className="bg-gradient-to-r from-indigo-500/10 to-purple-500/10 rounded-2xl p-6 mb-8 border border-indigo-400/20">
            <h4 className="text-xl font-light text-white mb-4 text-center">รายละเอียดงาน</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-center">
              <div>
                <div className="text-indigo-300 font-medium">วันที่</div>
                <div className="text-white">21-23 พฤศจิกายน 2568</div>
                <div className="text-indigo-200 text-sm">09.00 - 17.00 น.</div>
              </div>
              <div>
                <div className="text-purple-300 font-medium">สถานที่</div>
                <div className="text-white">S Ratchada Leisure Hotel</div>
                <div className="text-purple-200 text-sm">ห้อง Galleria ชั้น 2</div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <motion.a
            href="https://www.fengshuix.com/event-details/the-bazi-blueprint"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 text-white py-6 rounded-2xl text-xl font-light shadow-2xl hover:shadow-yellow-500/25 transition-all duration-300 flex items-center justify-center space-x-3"
            whileHover={{scale: 1.02,y: -2}}
            whileTap={{scale: 0.98}}
          >
            <span>จองที่นั่งของคุณ ฿9,580 (นักศึกษา ฿7,580)</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </motion.a>
        </motion.div>

        {/* Value Proposition */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8,delay: 0.3}}
          viewport={{once: true}}
        >
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-6 border border-white/10 text-center">
            <SafeIcon icon={FiShield} className="w-12 h-12 text-blue-400 mx-auto mb-4" />
            <h4 className="text-lg font-light text-white mb-2">ป้องกันความผิดพลาด</h4>
            <p className="text-slate-400 text-sm font-light">การตัดสินใจที่ผิดเพียงครั้งเดียว อาจมีราคาสูงกว่านี้หลายเท่า</p>
          </div>
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-6 border border-white/10 text-center">
            <SafeIcon icon={FiStar} className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
            <h4 className="text-lg font-light text-white mb-2">ทักษะตลอดชีวิต</h4>
            <p className="text-slate-400 text-sm font-light">ความรู้ที่ติดตัวไปและใช้ได้จริงในทุกสถานการณ์</p>
          </div>
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-6 border border-white/10 text-center">
            <SafeIcon icon={FiGift} className="w-12 h-12 text-green-400 mx-auto mb-4" />
            <h4 className="text-lg font-light text-white mb-2">ROI ที่วัดไม่ได้</h4>
            <p className="text-slate-400 text-sm font-light">ความมั่นใจและความชัดเจนในการตัดสินใจ</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default InvestmentSection;